var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCellxpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3521 74.3317V63.1562",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5098 63.1562V74.3317",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6572 63.1562V65.8779C40.6572 67.4099 41.8995 68.6521 43.4314 68.6521C44.9634 68.6521 46.2056 67.4099 46.2056 65.8779V63.1562",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.323 19.6691V54.2984",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6692 30.803L15.5738 33.9062L18.4923 32.7319L22.1797 34.6633L29.3769 28.6678L31.5514 35.4978L34.5438 37.4947L40.0767 31.5803H47.504",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6692 54.7767H63.2122",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0964 19.1922H12.2188C11.0994 19.1922 10.1921 20.0995 10.1921 21.2189V43.3506",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6694 38.2052V21.219C76.6694 20.0995 75.7621 19.1923 74.6427 19.1923H68.6663",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1921 48.9205V60.6527C10.1921 61.7722 11.0994 62.6794 12.2188 62.6794H63.2132",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6104 79.8802H32.2498C30.8705 79.8802 29.7522 78.7619 29.7522 77.3826C29.7522 76.0032 30.8705 74.8849 32.2498 74.8849H54.6104C55.9897 74.8849 57.108 76.0032 57.108 77.3826C57.108 78.7619 55.9897 79.8802 54.6104 79.8802Z",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4236 39.4389L71.27 42.1952C71.4751 42.8628 72.0915 43.3183 72.7901 43.3183H80.2209C80.9196 43.3183 81.5359 42.8628 81.741 42.1952L82.5874 39.4389",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8152 50.9951V77.3959C63.8152 78.7681 64.9275 79.8816 66.2997 79.8816H86.7087C88.0809 79.8816 89.1932 78.7693 89.1932 77.3959V41.1965C89.1932 39.8243 88.0809 38.7108 86.7087 38.7108H66.2997C64.9275 38.7108 63.8152 39.8231 63.8152 41.1965V45.424",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2922 63.5485H88.7177",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0464 45.9306H68.0633",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7129 69.0518H75.4368",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7129 73.1992H84.6548",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7405 41.0148H32.2367",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1021 26.2345H25.3424",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2542 31.7901H60.5057C59.627 31.7901 58.9165 31.0784 58.9165 30.2009V27.1346C58.9165 26.2572 59.6282 25.5454 60.5057 25.5454H70.2542C71.1316 25.5454 71.8433 26.2572 71.8433 27.1346V30.2009C71.8433 31.0784 71.1316 31.7901 70.2542 31.7901Z",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6846 35.5167H46.7552",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6846 39.4389H46.7552",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6846 43.3616H46.7552",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6846 47.2847H46.7552",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6846 51.207H46.7552",
    stroke: "#344054",
    strokeWidth: 2.38436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.3867,
    height: 63.0724,
    fill: "white",
    transform: "translate(9 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCellxpert);
export default __webpack_public_path__ + "static/media/icon_cellxpert.3840fcf7abad48cb2cde95d0929b51fd.svg";
export { ForwardRef as ReactComponent };